import * as THREE from 'three'
import { FunctionComponent, useEffect, useRef } from 'react'

interface ReparentProps {
  targetParent: THREE.Object3D | null | undefined
  children?: JSX.Element | JSX.Element[] | null | any
}

const Reparent: FunctionComponent<ReparentProps> = (props) => {
  const holderRef = useRef<THREE.Object3D>()

  useEffect(() => {
    if (holderRef.current != null && props.targetParent != null) {
      holderRef.current?.removeFromParent()
      props.targetParent.add(holderRef.current)
    }
  }, [props.targetParent])

  return (
    <group ref={holderRef}>
      {props.children}
    </group>
  )
}

export default Reparent
